import { emptySplitApi } from "./empty-split-api";

export interface CPTCode {
  id: number;
  code: string;
  description: string;
}

type CPTCodesResponse = CPTCode[];

const cptCodesApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getCPTCodes: builder.query<CPTCodesResponse, string | undefined>({
      query: (search) => `cpt-codes/?search=${search ?? ""}&limit=100`,
      providesTags: ["CPTCodes"],
      transformResponse: (response: CPTCodesResponse) => {
        const uniqueCodes = new Map<string, CPTCode>();

        response.forEach((cptCode) => {
          if (!uniqueCodes.has(cptCode.code)) {
            uniqueCodes.set(cptCode.code, cptCode);
          }
        });

        return Array.from(uniqueCodes.values());
      }
    })
  })
});

export const { useGetCPTCodesQuery, useLazyGetCPTCodesQuery } = cptCodesApi;
